export default "__VITE_ASSET__DTYQsqWc__"